import {gql} from "@apollo/client";
import {Estimation} from "@App/types";

export interface CreateEstimationQuery {
    createEstimation: Estimation
}

export const CREATE_ESTIMATION = gql`
    mutation CreateEstimation(
        $organization: ID!,
        $email: String!,
        $phone: String,
        $tos: Boolean!,
        $marketing: Boolean,
        $services: [ID]!,
        $brand: ID,
        $generation: ID,
        $motorization: ID,
    ){
        createEstimation(
            input: {
                organization: $organization,
                email: $email,
                phone: $phone,
                tos: $tos,
                marketing: $marketing,
                calculation: {
                    services: $services
                    brand: $brand
                    generation: $generation
                    motorization: $motorization
                }
            }
        ) {
            id
        }
    }
`
